import http from "../http-common";
import axios from "axios";

class aiService {
    getPromptTools = () => http.get(`/ai/getPromptTools`);

    updateAiPrompt = (data) => http.post("/ai/updateAiPrompt", data);

    updateAiTool = (data) => http.post("/ai/updateAiTool", data);

    validateSqlQuery = (data) => http.post("/ai/validateSqlQuery", data);

    deleteQuery = (id) => http.delete(`/ai/deleteQuery/${id}`);
}

export default new aiService();